import type { PausedSeriesKind, ResumeSkipReason } from '@bt-common/schemas/bt/series-pause';

/** i18n key (common namespace) for the reason line of each pause kind. Exhaustive by construction. */
export const PAUSED_REASON_KEY: Readonly<Record<PausedSeriesKind, string>> = {
    tab_closed: 'pausedSeries.reasonTabClosed',
    breaker: 'pausedSeries.reasonBreaker',
};

/** i18n key for the message shown when a resume was refused. Exhaustive: a new skip reason won't compile without one. */
export const RESUME_SKIP_KEY: Readonly<Record<ResumeSkipReason, string>> = {
    not_found: 'pausedSeries.skipNotFound',
    not_paused: 'pausedSeries.skipNotPaused',
    series_ended: 'pausedSeries.skipSeriesEnded',
    series_cancelled: 'pausedSeries.skipSeriesCancelled',
};
